import Filter from "./filter";
import GpsPosition from "./gpsPosition";
import NavigatorPosition from "./navigatorPosition";
import ThematicMapLayerFilters from "./thematicMapLayerFilters";

export type NavigatorMove = (
  navigatorPosition: NavigatorPosition,
) => Promise<void>;
export type NavigatorMoveAllCompleted = () => void;
export type PlaybackIsPlaying = (isPlaying: boolean) => void;
export type SetFilters = (
  filters: Filter[],
  isProjectChanging: boolean,
) => Promise<void>;
export type SetThematicMapFilters = (
  thematicMapLayerFilters: ThematicMapLayerFilters | undefined,
) => void;
export type SetTableFilters = (tableFilters: Filter[]) => void;
export type SetGpsPosition = (gpsPosition: GpsPosition | null) => void;

export default class Navigable {
  public id: string | undefined = undefined;
  public navigatorMove: NavigatorMove | undefined = undefined;
  public navigatorMoveAllCompleted: NavigatorMoveAllCompleted | undefined =
    undefined;
  public playbackIsPlayingChanged: PlaybackIsPlaying | undefined = undefined;
  public setFilters: SetFilters | undefined = undefined;
  public setThematicMapFilters: SetThematicMapFilters | undefined = undefined;
  public setTableFilters: SetTableFilters | undefined = undefined;
  public setGpsPosition: SetGpsPosition | undefined = undefined;

  public function1: any;
}
